export const SHARE_BASKET_PARAMETER_NAME = 'parameters';
